<template>
  <div class="info">
    <el-form :model="form" ref="infoForm" label-width="120px" class="info-form">
      <el-form-item> </el-form-item>
      <el-form-item label="用户头像">
        <el-image
          :src="form.headImg"
          style="width: 120px; height: 120px; cursor: pointer"
          @click="look(form.headImg)"
        >
        </el-image>
        <!-- <headerPicture
          @getUrl="getImage($event)"
          :qrCodeUrl="form.avatarUrl"
        ></headerPicture> -->
      </el-form-item>
      <el-form-item label="用户ID">
        {{ form.uid || "--" }}
      </el-form-item>
      <el-form-item label="用户昵称" prop="name">
        <el-input
          v-model="form.nickName"
          style="width: 30%"
          maxlength="10"
          show-word-limit
          @change="updateName"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="name">
        {{ form.phone || "--" }}
      </el-form-item>
      <el-form-item label=" OPENID" prop="name">
        {{ form.openId || "--" }}
      </el-form-item>
      <el-form-item label="用户等级" prop="name">
        {{ form.vipLabel || "--" }}
      </el-form-item>
      <el-form-item label="用户推荐人ID" prop="name">
        {{ form.referrerId || "--" }}
      </el-form-item>
      <el-form-item label=" 可提现佣金" prop="name">
        {{ Number(form.commission).toFixed(2) || "--" }}
      </el-form-item>
      <el-form-item label="加入时间" prop="name">
        {{ form.inTime || "--" }}
      </el-form-item>
      <el-form-item label="最近访问时间" prop="name">
        {{ form.lastActiveTime || "--" }}
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img
        width="100%"
        fit="contain"
        :src="dialogImageUrl"
        alt=""
        style="width: 100%"
      />
    </el-dialog>
  </div>
</template>
<script>
import headerPicture from '@/components/upload/headerPicture.vue'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    headerPicture
  },
  data () {
    return {
      name: 'cdd',
      form: {},
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  created () {
    console.log(this.id)
    this.getInfo()
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  methods: {
    look (src) {
      this.dialogVisible = true
      this.dialogImageUrl = src
    },
    getInfo () {
      let params = {
        phone: this.phone
      }
      this.$api.matrixServerDetail(params).then(res => {
        this.form = res.data
        if (this.form.headImg == '') {
          this.form.headImg = 'https://fenxiao.muruji.com/internalSystem/71f27eab-8ee0-418f-87ca-06f040c5c876'
        }
      })
    },
    updateName () {
      let data = {
        uid: this.form.uid,
        nickName: this.form.nickName,
      }
      this.$api.matrixServerUpdateName(data).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
        }
      })
    },
    getImage (val) {
      let data = {
        id: this.form.id,
        avatarUrl: val,
        username: this.form.username
      }
      this.$api.updateUserInfo(data).then(res => {
        if (res.code == 0) {
          // this.$message({
          //   type: 'success',
          //   message: '修改成功'
          // })
        }
      })

    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog__header {
  background-color: #ffffff;
  border-bottom: none !important;
}
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

